<!--
 * @Author: lixiaodi
 * @Date: 2020-03-17 09:53:18
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-06-23 18:29:32
 -->
<template>
    <!-- 标题 -->
    <div class="share-title">
        <p class="title-sty">{{title}}</p>
        <p class="title-more" v-if="more" @click="gotoMore">更多 >></p>
    </div>
</template>

<script>

export default {
  name: 'modelTitle',
  props: ['content', 'more'],
  props: {
      content: {
          type: String,
          default: () => ""
      },
      more: {
          type: Boolean,
          default: true
      }
  },
  data() {
      return {
          title: this.content
      }
  },
  methods: {
        // 跳转至更多
        gotoMore (){
            // 根据标题判断跳转
            let jumpPath = ''

            let categoryname = '';
            switch (this.content){
                case '摄影图片':
                    categoryname='摄影图片';
                    jumpPath = 'pictureList';
                    break
              case '插图':
                categoryname='插图';
                jumpPath = 'pictureList';
                break
              case '轨道交通':
                categoryname='轨道交通';
                jumpPath = 'pictureList';
                break
              case '老照片':
                categoryname='老照片';
                jumpPath = 'pictureList';
                break
                default:
                    jumpPath = 'index'
            }

              this.$router.push({
                path: jumpPath,
                query: {
                  categoryname: categoryname
                }
              })

        }
    }
}
</script>
<style lang="stylus" scoped>
/* 标题 */
.share-title{
    font-size: 0.2rem;
    font-weight: bold;
    color: #fff;
    padding: 0.18rem 0.1rem;
    background: #228457;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.title-sty{
    font-weight 700
}
.title-more{
    color #ffffff
    cursor pointer
}
</style>



// WEBPACK FOOTER //
// src/components/Education/commonView/modelTitle.vue